/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchTaxReportResponse } from './search-tax-report-response';


export interface SearchTaxReportResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchTaxReportResponse> | null;
}

